import { render, staticRenderFns } from "./viewFraudCase.vue?vue&type=template&id=6bc6ef07"
import script from "./viewFraudCase.vue?vue&type=script&lang=js"
export * from "./viewFraudCase.vue?vue&type=script&lang=js"
import style0 from "./viewFraudCase.vue?vue&type=style&index=0&id=6bc6ef07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports